module.exports = __webpack_public_path__ + "assets/images/amira_action_failed.1232818728a9a6b3df2c0a17a441d95b.svg";